import React, { useEffect, useRef ,useState} from "react";
import { useNavigate } from "react-router-dom";
import "./OpenAccessSolar.css";

// Images
import heroImage from "../../assets/Solar-team.png";
import thumbImage from "../../assets/solar-thumb.png";
import solarPanelImage from "../../assets/Open-Access-Solar.png";
import solarGridImage from "../../assets/Open-Solar-benefits.png";
import IconManufacturers from "../../assets/Manufacturers.png";
import IconPharma from "../../assets/Pharma.png";
import IconFMCG from "../../assets/FMCG.png";
import IconITPark from "../../assets/IT.png";
import IconDataCenter from "../../assets/Data.png";
import IconTexiles from "../../assets/textiles.png";
import IconWarehouse from "../../assets/Warehouse.png";
import IconAutomotive from "../../assets/Automotive.png";
import IconSteel from "../../assets/Steel.png";
import IconChemical from "../../assets/chemical.png";
import stage1 from "../../assets/stage1.png";
import stage2 from "../../assets/design.png";
import stage3 from "../../assets/validation.png";
import stage4 from "../../assets/eligibility.png";
import stage5 from "../../assets/solar.png";
import stage6 from "../../assets/design.png";
import stage7 from "../../assets/solar2.png";
import stage8 from "../../assets/maintainance.png";
import stage9 from "../../assets/solar.png";
import stage10 from "../../assets/training.png";
import stage11 from "../../assets/solar2.png";
import stage12 from "../../assets/solar3.png";
import chooseImg from "../../assets/opena-whychoose.png";
// import Testi1 from "../../assets/testi1.png";
// import Testi2 from "../../assets/testi2.png";
// import Testi3 from "../../assets/testi3.png";
import featuredproj1 from "../../assets/CIRsection6-1.png";
import featuredproj2 from "../../assets/CIRsection6-2.png";
import solar1 from "../../assets/PMKusumsection1.png";
import solar3 from "../../assets/solar2.png";
import solar4 from "../../assets/solar3.png";
import solar5 from "../../assets/opensolutions-4.png";
import solar6 from "../../assets/opensolutions-5.png";
import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import finalStep1 from "../../assets/finalstep1.png";
import finalStep2 from "../../assets/finalstep2.png";
import finalStep3 from "../../assets/finalstep3.png";
import openFinancial1 from "../../assets/openfinancial-1.png";
import openFinancial2 from "../../assets/openfinancial-2.png";
import openFinancial3 from "../../assets/openfinancial-3.png";
import openFinancial4 from "../../assets/openfinancial-4.png";
import openFinancial5 from "../../assets/openfinancial-5.png";
import oas1step1 from "../../assets/OA-s1-step1.png";
import oas1step2 from "../../assets/OA-s1-step2.png";
import oas1step3 from "../../assets/OA-s1-step3.png";
import oas1step4 from "../../assets/OA-s1-step4.png";
import oas1step5 from "../../assets/OA-s1-step5.png";
import oas1step6 from "../../assets/OA-s1-step6.png";
import oas2step1 from "../../assets/OA-s2-step1.png";
import oas2step2 from "../../assets/OA-s2-step2.png";
import oas2step3 from "../../assets/OA-s2-step3.png";
import oas2step4 from "../../assets/OA-s2-step4.png";
import oas2step5 from "../../assets/OA-s2-step5.png";
import oas2step6 from "../../assets/OA-s2-step6.png";
import oas2step7 from "../../assets/OA-s2-step7.png";
import oas3step1 from "../../assets/OA-s3-step1.png";
import oas3step2 from "../../assets/OA-s3-step2.png";
import oas4step1 from "../../assets/OA-s4-step1.png";
import oas4step2 from "../../assets/OA-s4-step2.png";
import oas4step3 from "../../assets/OA-s4-step3.png";
import oas4step4 from "../../assets/OA-s4-step4.png";
import oas4step5 from "../../assets/OA-s4-step5.png";
import oas4step6 from "../../assets/OA-s4-step6.png";
import oas4step7 from "../../assets/OA-s4-step7.png";
import oas4step8 from "../../assets/OA-s4-step8.png";
import oas5step1 from "../../assets/OA-s5-step1.png";
import oas5step2 from "../../assets/OA-s5-step2.png";
import oas5step3 from "../../assets/OA-s5-step3.png";
import oas5step4 from "../../assets/OA-s5-step4.png";
import oas5step5 from "../../assets/OA-s5-step5.png";
import oas5step6 from "../../assets/OA-s5-step6.png";
import oas5step7 from "../../assets/OA-s5-step7.png";
import oas5step8 from "../../assets/OA-s5-step8.png";
import oas6step1 from "../../assets/OA-s6-step1.png";
import oas6step2 from "../../assets/OA-s6-step2.png";
import oas6step3 from "../../assets/OA-s6-step3.png";
import oas6step4 from "../../assets/OA-s6-step4.png";
import oas6step5 from "../../assets/OA-s6-step5.png";
import oas6step6 from "../../assets/OA-s6-step6.png";
import oas6step7 from "../../assets/OA-s6-step7.png";
import oas7step1 from "../../assets/OA-s7-step1.png";
import oas7step2 from "../../assets/OA-s7-step2.png";
import oas7step3 from "../../assets/OA-s7-step3.png";
import oas7step4 from "../../assets/OA-s7-step4.png";
import oas7step5 from "../../assets/OA-s7-step5.png";
import oas7step6 from "../../assets/OA-s7-step6.png";
import oas7step7 from "../../assets/OA-s7-step7.png";
import oas7step8 from "../../assets/OA-s7-step8.png";
import oas8step1 from "../../assets/OA-s8-step1.png";
import oas8step2 from "../../assets/OA-s8-step2.png";
import oas8step3 from "../../assets/OA-s8-step3.png";
import oas8step4 from "../../assets/OA-s8-step4.png";
import oas8step5 from "../../assets/OA-s8-step5.png";
import oas8step6 from "../../assets/OA-s8-step6.png";
import oas8step7 from "../../assets/OA-s8-step7.png";
import oas9step1 from "../../assets/OA-s9-step1.png";
import oas9step2 from "../../assets/OA-s9-step2.png";
import oas9step3 from "../../assets/OA-s9-step3.png";
import oas9step4 from "../../assets/OA-s9-step4.png";
import oas9step5 from "../../assets/OA-s9-step5.png";
import oas9step6 from "../../assets/OA-s9-step6.png";
import oas9step7 from "../../assets/OA-s9-step7.png";
import oas10step1 from "../../assets/OA-s10-step1.png";
import oas10step2 from "../../assets/OA-s10-step2.png";
import oas10step3 from "../../assets/OA-s10-step3.png";
import oas10step4 from "../../assets/OA-s10-step4.png";
import oas10step5 from "../../assets/OA-s10-step5.png";
import oas10step6 from "../../assets/OA-s10-step6.png";
import oas10step7 from "../../assets/OA-s10-step7.png";
import oas11step1 from "../../assets/OA-s11-step1.png";
import oas11step2 from "../../assets/OA-s11-step2.png";
import oas11step3 from "../../assets/OA-s11-step3.png";
import oas11step4 from "../../assets/OA-s11-step4.png";
import oas11step5 from "../../assets/OA-s11-step5.png";
import oas11step6 from "../../assets/OA-s11-step6.png";
import oas11step7 from "../../assets/OA-s11-step7.png";
import oas11step8 from "../../assets/OA-s11-step8.png";
import oas12step1 from "../../assets/OA-s12-step1.png";
import oas12step2 from "../../assets/OA-s12-step2.png";
import oas12step3 from "../../assets/OA-s12-step3.png";
import oas12step4 from "../../assets/OA-s12-step4.png";
import oas12step5 from "../../assets/OA-s12-step5.png";
import oas12step6 from "../../assets/OA-s12-step6.png";
import oas12step7 from "../../assets/OA-s12-step7.png";
import oas12step8 from "../../assets/OA-s12-step8.png";

const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);
  return ref;
};

/* ======================================================
   SECTION 1 — HERO
====================================================== */
const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="hero">
      <div className="hero__orange-bg" />

      <div className="hero__image-wrap">
        <img
          src={heroImage}
          alt="Solar panel workers"
          className="hero__image"
        />
      </div>

      <div className="hero__content">
        <h1 className="hero__heading">
          Direct Access to Low-Cost Renewable Energy for C&I Consumers
        </h1>

        <p className="hero__desc">
          Procure renewable power at lower tariffs through structured open
          access—without owning or operating the plant.
        </p>

        <div className="cta">
          <button onClick={() => navigate("/contact")}>Book A Free Call</button>
        </div>

        <div className="hero__thumb">
          <img src={thumbImage} alt="Solar installation" loading="lazy" />
        </div>
      </div>
    </section>
  );
};

/* ======================================================
   SECTION 2 — OVERVIEW (WORD-BY-WORD SCROLL)
====================================================== */
const OverviewSection = () => {
  const textRef = useRef();

  const text = `The Open Access (OA) Solar Model allows commercial and industrial (C&I) consumers to procure power directly from large-scale solar plants located anywhere within the state (Intra-State OA) or across states (Inter-State OA).`;

  useEffect(() => {
    const words = textRef.current.querySelectorAll(".word");

    const handleScroll = () => {
      const rect = textRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      let progress = (windowHeight - rect.top) / windowHeight;
      progress = Math.max(0, Math.min(1, progress));

      const wordsToShow = Math.floor(progress * words.length);

      words.forEach((word, index) => {
        word.style.color = index < wordsToShow ? "#111" : "#6D6E70";
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="open_overview">
      <span className="open_overview__label">
        <span className="open_overview__dot" />
        OVERVIEW
      </span>

      <p ref={textRef} className="open_overview__text">
        {text.split(" ").map((word, index) => (
          <span key={index} className="word">
            {word}&nbsp;
          </span>
        ))}
      </p>
    </section>
  );
};

/* ======================================================
   SECTION 3 — CAPTIVE MODEL EXPLAINER
====================================================== */
const ExplainerSection = () => {
  return (
    <section className="open_acces-model">
      <div className="open_acces-model-container">
        <div className="open_acces-model__content">
          <div>
            <p className="open_acces-model__intro">
              Open Access allows eligible consumers (≥1 MW sanctioned load in
              most states) to buy renewable energy directly from a solar plant
              using the state’s transmission and distribution network.
            </p>

            <p className="open_acces-model__sub-heading">
              Businesses benefit from:
            </p>

            <ul className="open_acces-model__list">
              <li>Lower tariffs vs DISCOM grid supply</li>
              <li>Long-term price certainty</li>
              <li>No capex or ownership burden (in OPEX/BOOT models)</li>
              <li>High-quality renewable energy for ESG targets</li>
              <li>Flexible contract structures</li>
            </ul>
          </div>

          <p className="open_acces-model__tagline">
            Open Access is ideal for companies seeking deep cost reduction
            without investing in plant ownership.
          </p>
        </div>

        <div className="open_acces-model__image-wrap">
          <img
            src={solarPanelImage}
            alt="Solar panel installation"
            className="open_acces-model__image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

/* ================================================
   3. OUR SOLUTIONS
   ================================================ */
const solutions = [
  {
    id: 1,
    image: solar1,
    title: "Intra-State Open Access",
    desc: "Power procured from solar plants within the same state.",
  },
  {
    id: 2,
    image: solar3,
    title: "Inter-State Open Access (ISTS)",
    desc: "Power procured from solar plants in other states through central transmission lines.",
  },
  {
    id: 3,
    image: solar4,
    title: "OPEX / BOOT Open Access",
    desc: "Pay only for power (₹/kWh). No investment required.",
  },
  {
    id: 4,
    image: solar5,
    title: "Third-Party Open Access",
    desc: "Buy power directly from a developer through a PPA.",
  },
  {
    id: 5,
    image: solar6,
    title: "Captive / Group Captive Open Access",
    desc: "Combine OA with equity ownership for additional benefits.",
  },
];

const OpenAccessSolutions = () => {
  const outerRef = useRef(null);
  const trackRef = useRef(null);

  const headingRef = useRef(null);
  useEffect(() => {
    const el = headingRef.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        const cards = trackRef.current?.querySelectorAll(
          ".open-sol-card-animate",
        );
        cards?.forEach((card) => card.classList.add("is-visible"));
        window.removeEventListener("scroll", check);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);

  useEffect(() => {
    const outer = outerRef.current;
    const track = trackRef.current;
    if (!outer || !track) return;

    let current = 0;
    let target = 0;
    let raf;

    const ease = 0.12;

    const update = () => {
      current += (target - current) * ease;
      track.style.transform = `translate3d(-${current}px,0,0)`;
      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      const rect = outer.getBoundingClientRect();
      const startOffset = window.innerHeight * 0.12;
      const end = outer.offsetHeight - window.innerHeight;
      let progress = (-rect.top - startOffset) / end;
      const clamped = Math.max(0, Math.min(1, progress));
      const containerWidth = track.parentElement.offsetWidth;
      const maxTranslate = track.scrollWidth - containerWidth;
      target = clamped * maxTranslate;
    };

    window.addEventListener("scroll", onScroll);
    raf = requestAnimationFrame(update);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className="open-sol-outer" ref={outerRef}>
      <div className="open-sol-sticky">
        <div className="open-sol-container">
          <div className="open-sol-heading reveal-block" ref={headingRef}>
            <p className="open-sol-label">
              <span className="open-sol-dot"></span> OPEN ACCESS SOLUTIONS
            </p>
            <h2 className="open-sol-title">Types of Open Access</h2>
            <p className="open-sol-subtitle">
              Every solution is delivered through our unified digital ecosystem
              for complete transparency and long-term reliability.
            </p>
          </div>

          <div className="open-sol-track-outer">
            <div className="open-sol-track" ref={trackRef}>
              {solutions.map((s, i) => (
                <div
                  className="open-sol-card open-sol-card-animate"
                  key={s.id}
                  style={{ "--card-delay": `${i * 0.1}s` }}
                >
                  <div className="open-sol-img-wrap">
                    <img src={s.image} alt={s.title} className="sol-img" loading="lazy" />
                  </div>
                  <div className="open-sol-card-body">
                    <h3 className="open-sol-card-title">{s.title}</h3>
                    <p className="open-sol-card-desc">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ======================================================
   SECTION 5 — Financial Benefits
====================================================== */
const oaFinancialBenefitItems = [
  {
    title: "30–55% cheaper than DISCOM power",
    desc: "State-dependent charges apply, but the landed cost remains significantly lower.",
    image: openFinancial1,
  },
  {
    title: "Long-term tariff stability (up to 25 years)",
    desc: "No fuel risk, no tariff escalation shocks.",
    image: openFinancial2,
  },
  {
    title: "Zero capex option available",
    desc: "OPEX/BOOT models eliminate investment barriers.",
    image: openFinancial3,
  },
  {
    title: "ESG & sustainability compliance",
    desc: "Companies significantly reduce GHG emissions and improve sustainability ratings.",
    image: openFinancial4,
  },
  {
    title: "Power procurement flexibility",
    desc: "Contract terms can be customized based on consumption patterns.",
    image: openFinancial5,
  },
];

const OpenSolarFinancialBenefits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const outerRef = useRef(null);
  const activeIndexRef = useRef(0);

  /* ── Pin the panel while scrolling through the outer (tall) wrapper,
     driving activeIndex from scroll progress. ── */
  useEffect(() => {
    let raf;

    const update = () => {
      const el = outerRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const totalScroll = el.offsetHeight - window.innerHeight;
        const scrolled = -rect.top;
        const p =
          totalScroll > 0
            ? Math.max(0, Math.min(scrolled / totalScroll, 1))
            : 0;

        const idx = Math.min(
          oaFinancialBenefitItems.length - 1,
          Math.floor(p * oaFinancialBenefitItems.length)
        );

        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const timer = setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="open_acces-financial-benefits-outer"
      ref={outerRef}
      style={{ height: `${oaFinancialBenefitItems.length * 110}vh` }}
    >
      <section className="open_acces-financial-benefits-sticky">
        <div className="open_acces-financial-benefits">
          {/* ── Centered header ── */}
          <div className="open_acces-financial-benefits-header">
            <p className="open_acces-financial-benefits-tag">
              <span className="open_acces-financial-benefits-dot" />
              FINANCIAL BENEFITS
            </p>
            <h2 className="open_acces-financial-benefits-title">
              Driven by Returns. Backed by Structure.
            </h2>
          </div>

          {/* ── Body: list left + image right ── */}
          <div className="open_acces-financial-benefits-body">
            {/* Left benefit items */}
            <div className="open_acces-financial-benefits-list">
              {oaFinancialBenefitItems.map((item, i) => (
                <div key={i}>
                  <div
                    className={`open_acces-financial-benefit-item ${
                      i === activeIndex
                        ? "open_acces-financial-benefit-item--active"
                        : ""
                    }`}
                    onClick={() => setActiveIndex(i)}
                    onMouseEnter={() => setActiveIndex(i)}
                  >
                    {/* Orange bar — only for active */}
                    {i === activeIndex && (
                      <span className="open_acces-financial-benefit-bar" />
                    )}

                    <div className="open_acces-financial-benefit-text">
                      <p className="open_acces-financial-benefit-title">
                        {item.title}
                      </p>

                      {/* Desc — only for active, animates in */}
                      {i === activeIndex && (
                        <p className="open_acces-financial-benefit-desc">
                          {item.desc}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Mobile-only inline image — appears below the active item */}
                  <div className="oa-benefit-mobile-img-wrap">
                    <div className="oa-benefit-mobile-img-bg" />
                    <img
                      src={item.image}
                      alt={item.title}
                      className="oa-benefit-mobile-img"
                      loading="lazy"
                    />
                  </div>

                  {i < oaFinancialBenefitItems.length - 1 && (
                    <hr className="open_acces-financial-benefit-divider" />
                  )}
                </div>
              ))}
            </div>

            {/* Right image with blue offset block */}
            <div className="open_acces-financial-benefits-img-wrap">
              <div className="open_acces-financial-benefits-img-bg" />
              <img
                key={activeIndex}
                src={oaFinancialBenefitItems[activeIndex].image}
                alt={oaFinancialBenefitItems[activeIndex].title}
                className="open_acces-financial-benefits-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
/* ================================================
   SECTION — WHO IT'S FOR (CAPTIVE)
   ================================================ */

const WHO_ITEMS = [
  { label: "Manufacturing", icon: IconManufacturers },
  { label: "Pharma", icon: IconPharma },
  { label: "FMCG", icon: IconFMCG },
  { label: "Textiles", icon: IconTexiles },
  { label: "IT Parks", icon: IconITPark },
  { label: "Data Centers", icon: IconDataCenter },
  { label: "Logistic Parks", icon: IconWarehouse },
  { label: "Automotive", icon: IconAutomotive },
  { label: "Steel & Fabrication", icon: IconSteel },
  { label: "Chemical", icon: IconChemical },
];

const OpenWhoItsFor = () => {
  // split items into 2 rows
  const topRow = WHO_ITEMS.slice(0, 5);
  const bottomRow = WHO_ITEMS.slice(5);

  // duplicate for seamless loop
  const topTicker = [...topRow, ...topRow, ...topRow, ...topRow];
  const bottomTicker = [...bottomRow, ...bottomRow, ...bottomRow, ...bottomRow];

  return (
    <section className="open-access-who-section">
      {/* Header */}
      <div className="open-access-who-header">
        <p className="open-access-who-tag">
          <span className="open-access-who-dot" />
          IDEAL FOR
        </p>

        <h2 className="open-access-who-title">
          Ideal for Tariff-Sensitive<br className="who-title-mobile-br" /> Businesses
        </h2>

        <p className="open-access-who-subtitle">
          Designed for high-load consumers looking to reduce electricity costs
          through structured open access procurement.
        </p>
      </div>

      {/* Ticker */}
      <div className="open-access-who-ticker">
        <div className="open-access-who-track">
          {/* 🔹 TOP ROW → RIGHT */}
          <div className="open-access-who-row open-access-who-row-top">
            {topTicker.map((item, i) => (
              <div className="open-access-who-card" key={`top-${i}`}>
                <img
                  src={item.icon}
                  alt={item.label}
                  className="open-access-who-card-icon"
                  loading="lazy"
                />
                <p className="open-access-who-card-label">{item.label}</p>
              </div>
            ))}
          </div>

          {/* 🔹 BOTTOM ROW → LEFT */}
          <div className="open-access-who-row open-access-who-row-bottom">
            {bottomTicker.map((item, i) => (
              <div className="open-access-who-card" key={`bottom-${i}`}>
                <img
                  src={item.icon}
                  alt={item.label}
                  className="open-access-who-card-icon"
                  loading="lazy"
                />
                <p className="open-access-who-card-label">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 6 — HOW IT WORKS SECTION
   ================================================ */
const stages = [
  {
    id: 1,
    title: "Consumption & Feasibility",
    image: stage1,
    steps: [
      { title: "12-36 month consumption study",image: oas1step1 },
      { title: "Peak, off-peak, seasonal, and Sunday load behaviour",image: oas1step2 },
      { title: "OA suitability vs captive vs group captive comparison",image: oas1step3 },
      { title: "State-wise OA regulations analysis",image: oas1step4 },
      { title: "HT feeder mapping & energy profile characterization",image: oas1step5 },
      { title: "Identification of ideal OA contract size (MW)",image: oas1step6 },
    ],
  },
  {
    id: 2,
    title: "Tariff & Savings Model",
    image: stage2,
    steps: [
      { title: "Banking, wheeling, CSS, STU, transmission, SLDC mapping", image: oas2step1 },
      { title: "Monthly landed tariff calculation", image: oas2step2 },
      { title: "25-year savings modelling vs DISCOM tariff escalation", image: oas2step3 },
      { title: "OA scenario modelling: STOA / MTOA / LTOA", image: oas2step4 },
      { title: "Hybrid OA + Captive savings mix", image: oas2step5 },
      { title: "Sensitivity modelling for OA charge changes", image: oas2step6 },
      { title: "Final delivered energy cost forecasting", image: oas2step7 },
    ],
  },
  {
    id: 3,
    title: "Plant Identification",
    image: stage3,
    steps: [
      {
        title: "Use an existing OA-ready plant:", image: oas3step1,
        bullets: [
          "Due diligence of generation history",
          "SCADA compliance check",
          "Metering & ABT readiness",
          "Evacuation capacity verification",
        ],
      },
      {
        title: "Develop a new OA plant:",
        image: oas3step2,
        bullets: [
          "Land identification & procurement",
          "Evacuation route engineering",
          "Substation & bay availability",
          "Environmental & statutory considerations",
        ],
      },
    ],
  },
  {
    id: 4,
    title: "PPA Structuring",
    image: stage4,
    steps: [
      { title: "OPEX PPA drafting (10–25 years)" , image: oas4step1},
      { title: "Tariff structure: fixed, escalable, hybrid" , image: oas4step2},
      { title: "Minimum off-take commitment" , image: oas4step3},
      { title: "Generation guarantee clauses" , image: oas4step4},
      { title: "Banking rules & settlement terms" , image: oas4step5},
      { title: "SLDC scheduling responsibility allocation" , image: oas4step6},
      { title: "OA risk mitigation structures" , image: oas4step7},
      { title: "Optional: Green OA compliance structuring" , image: oas4step8},
    ],
  },
  {
    id: 5,
    title: "OA Approvals",
    image: stage5,
    steps: [
      { title: "DISCOM NOC for OA" , image: oas5step1},
      { title: "SLDC approval for scheduling & forecasting" , image: oas5step2},
      { title: "Transmission & wheeling approvals" , image: oas5step3},
      { title: "Consent for drawal across feeders" , image: oas5step4},
      { title: "CEIG/CEA statutory certification" , image: oas5step5},
      { title: "Banking rules verification (state-level)" , image: oas5step6},
      { title: "OA workflow tracker inside TrueTrack™" , image: oas5step7},
      { title: "Automated alerts for deadlines and missing documents" , image: oas5step8},
    ],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    image: stage6,
    steps: [
      { title: "Array layout, SLDs, inverter/transformer sizing" , image: oas6step1},
      { title: "OA-compliant ABT metering architecture" , image: oas6step2},
      { title: "SCADA system design for integrated OA reporting" , image: oas6step3},
      { title: "BOQ finalization with approved vendors" , image: oas6step4},
      { title: "Material dispatch schedules with real-time tracking" , image: oas6step5},
      { title: "Quality checks on modules​/inverters/MMS/transformers" , image: oas6step6},
      { title: "Digital engineering checklists" , image: oas6step7},
    ],
  },
  {
    id: 7,
    title: "EPC Execution",
    image: stage7,
    steps: [
      { title: "Daily EPC progress: civil, MMS, DC, AC works" , image: oas7step1},
      { title: "Photographic & video reporting" , image: oas7step2},
      { title: "Automated milestone tracking" , image: oas7step3},
      { title: "Worker/manpower deployment logs" , image: oas7step4},
      { title: "Material consumption & pending delivery insights" , image: oas7step5},
      { title: "Timeline deviation alerts" , image: oas7step6},
      { title: "Stakeholder dashboards for: OA buyer, Investors, EPC oversight" , image: oas7step7},
      { title: "Transparent, accountable EPC execution" , image: oas7step8},
    ],
  },
  {
    id: 8,
    title: "Testing & Metering",
    image: stage8,
    steps: [
      { title: "ABT meter installation & sealing with DISCOM" , image: oas8step1},
      { title: "CT/PT testing & accuracy check" , image: oas8step2},
      { title: "PRE-commissioning test reports (DC/AC validation)" , image: oas8step3},
      { title: "OA metering compliance (import/export type)" , image: oas8step4},
      { title: "SCADA-meter integration" , image: oas8step5},
      { title: "Trial generation & stability checks" , image: oas8step6},
      { title: "Final CEIG approval & grid synchronization" , image: oas8step7},
    ],
  },
  {
    id: 9,
    title: "Live Monitoring & Scheduling",
    image: stage9,
    steps: [
      { title: "Real-time generation, PR, CUF & inverter performance" , image: oas9step1},
      { title: "Grid export monitoring in compliance with OA rules" , image: oas9step2},
      { title: "Forecasting engine for SLDC scheduling" , image: oas9step3},
      { title: "AI alerts: string drop, inverter failure, grid issues" , image: oas9step4},
      { title: "Weather-adjusted performance analytics" , image: oas9step5},
      { title: "Scheduling deviation impact analysis (UDS/DD penalties)" , image: oas9step6},
      {
        title: "Dual dashboards:", image: oas9step7,
        bullets: [
          "Engineering dashboard: SCADA depth",
          "Consumer dashboard: drawal, savings, OA adjustments",
        ],
      },
    ],
  },
  {
    id: 10,
    title: "O&M and Asset Health",
    image: stage10,
    steps: [
      { title: "Preventive maintenance planner" , image: oas10step1},
      { title: "Thermography & drone inspections" , image: oas10step2},
      { title: "Transformer, HT line & evacuation health check" , image: oas10step3},
      { title: "Inverter thermal cycle analysis" , image: oas10step4},
      { title: "Ticketing system with SLA-bound closure" , image: oas10step5},
      {
        title: "OA performance reporting:", image: oas10step6,
        bullets: [
          "Losses due to outages",
          "Deviations vs scheduled energy",
          "Substation impact analysis",
        ],
      },
      { title: "Monthly digital asset health reports" , image: oas10step7},
    ],
  },
  {
    id: 11,
    title: "Billing & OA Settlement",
    image: stage11,
    steps: [
      { title: "Automated OA billing (per unit or PPA-based)" , image: oas11step1},
      { title: "Integration of ABT meter data" , image: oas11step2},
      { title: "SLDC schedule vs actual settlement" , image: oas11step3},
      { title: "Wheeling, banking, CSS, STU & SLDC charge reconciliation" , image: oas11step4},
      { title: "Import/export adjustments" , image: oas11step5},
      { title: "PPA compliance logging" , image: oas11step6},
      { title: "Payment reminders & invoice management" , image: oas11step7},
      { title: "Transparent settlement dashboards for CFOs & OA buyers" , image: oas11step8},
    ],
  },
  {
    id: 12,
    title: "Lifecycle & Reporting",
    image: stage12,
    steps: [
      { title: "Monthly & annual OA performance analytics", image: oas12step1 },
      { title: "Savings, avoided cost & IRR reporting", image: oas12step2 },
      { title: "ESG-ready Scope 2 impact documentation", image: oas12step3 },
      { title: "Carbon credit eligibility (REC, I-REC, VER)", image: oas12step4 },
      { title: "Long-term performance benchmarking", image: oas12step5 },
      { title: "Portfolio view for multi-site OA clients", image: oas12step6 },
      { title: "Contract extension & renegotiation guidance", image: oas12step7 },
      { title: "Lifecycle optimization recommendations", image: oas12step8 },
    ],
  },
];

const N = stages.length;
const ANGLE_STEP = 30;
const MINOR_TICKS = 72;

const HowItWorks = () => {
  const sectionRef = useRef(null);
  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);
  const activeStageRef = useRef(0);
  const logoRef = useRef(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const startDelay = headerHeight + window.innerHeight * 0.2;
      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;
      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * N;
      const activeFloat = Math.min(arcFloat, N - 1);
      const activeIndex = Math.round(activeFloat);
      const currentRotation = -(activeFloat * ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current) {
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      }
      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      stages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;
        const dist = activeFloat - i;
        let opacity = 1;
        if (Math.abs(dist) < 0.5) opacity = 0;
        else if (dist > 0.5) opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        else if (dist < -5) opacity = 0;
        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1;
        itemEl.style.opacity = opacity;
        numEl.style.transform = `rotate(${-(i * ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      if (arcRef.current) {
        const progress = Math.max(0, Math.min(arcFloat, N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex);
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = stages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");
  const cardsData = currentStage.steps;
  const stepImages = [finalStep1, finalStep2, finalStep3];

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      const scrollAmount = cardsContainerRef.current.offsetWidth;
      cardsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="hiw-outer"
      ref={sectionRef}
      style={{ height: `${stages.length * 110}vh` }}
    >
      <div className="hiw-header-wrap">
        <div className="hiw-tag">
          <span className="hiw-dot"></span>
          HOW IT WORKS
        </div>
        <h2 className="hiw-title">True 360° Execution Cycle</h2>
        <p className="hiw-subtitle">
          A complete, integrated 12-stage solar development framework powered by
          TrueTrack™, TrueCare™ &amp; TrueCom™.
        </p>
      </div>

      <div className="hiw-sticky">
        <div className="hiw-split">
          <div className="hiw-left">
            <div className="hiw-mobile-header">
              <div className="hiw-tag">
                <span className="hiw-dot"></span>
                HOW IT WORKS
              </div>
              <h2 className="hiw-title">True 360° Execution Cycle</h2>
              <p className="hiw-subtitle">
                A complete, integrated 12-stage OA solar framework.
              </p>
            </div>

            <div className="hiw-dial-wrapper">
              <div className="hiw-dial-container" ref={dialRef}>
                <div className="hiw-dial-bg"></div>
                <div className="hiw-dial-inner-orange"></div>

                {Array.from({ length: MINOR_TICKS }).map((_, i) => (
                  <div
                    key={`tick-${i}`}
                    className="hiw-dial-tick-min"
                    style={{ transform: `rotate(${i * (360 / MINOR_TICKS)}deg) translate(380px)` }}
                  />
                ))}

                <svg
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "678px",
                    height: "678px",
                    pointerEvents: "none",
                    zIndex: 2,
                  }}
                >
                  <circle
                    ref={arcRef}
                    cx="339"
                    cy="339"
                    r="333"
                    fill="none"
                    stroke="#F05A28"
                    strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333}
                    strokeDashoffset={2 * Math.PI * 333}
                    strokeLinecap="round"
                  />
                </svg>

                {stages.map((stage, i) => {
                  const itemAngle = i * ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;
                  return (
                    <React.Fragment key={stage.id}>
                      <div
                        className={`hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(380px)` }}
                      />
                      <div
                        className={`hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(420px)` }}
                      >
                        <div
                          className="hiw-dial-num"
                          ref={(el) => (numRefs.current[i] = el)}
                          style={{ transform: "rotate(-90deg)" }}
                        >
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              <div className="hiw-dial-inner">
                <img
                  src={trueRenewablesLogo}
                  alt="True Renewables"
                  className="hiw-center-logo"
                  ref={logoRef}
                  loading="lazy"
                />
                <div className="hiw-dial-pointer"></div>
              </div>

              <div className="hiw-active-overlay">
                <div className="hiw-inner-faint-line"></div>
                <div className="hiw-active-thick-line"></div>
                <div className="hiw-active-dot"></div>
                <div className="hiw-active-text-block">
                  <span className="hiw-active-num">{numStr}</span>
                  <span className="hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>

            <div className="hiw-mobile-info">
              <div className="hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="hiw-mobile-title">{currentStage.title}</h3>
              <p className="hiw-mobile-desc">
                {currentStage.steps.map((s) => s.title).join(", ")}
              </p>
              <button
                className="hiw-mobile-view-btn"
                onClick={() => setIsMobilePopupOpen(true)}
              >
                VIEW DETAILS ↗
              </button>
            </div>
          </div>

          <div className={`hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}>
            <div className="hiw-popup-bg" onClick={() => setIsMobilePopupOpen(false)}></div>
            <div className="hiw-popup-inner">
              <button className="hiw-popup-close" onClick={() => setIsMobilePopupOpen(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div className="hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="hiw-right-title">{currentStage.title}</h2>

              <div className="hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="hiw-step-card">
                    <div className="hiw-step-img-wrap">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="hiw-step-img"
                        loading="lazy"
                      />
                    </div>
                    <div className="hiw-step-text">
                      <p className="hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="hiw-step-bullets">
                          {step.bullets.map((bullet, bi) => (
                            <li key={bi} className="hiw-step-bullet">{bullet}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="hiw-nav-arrows">
                <button type="button" className="hiw-nav-arrow" onClick={() => scrollCards("left")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <button type="button" className="hiw-nav-arrow" onClick={() => scrollCards("right")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================================================
   SECTION 7 — WHY CHOOSE US
   ================================================ */
const OpenWhyChooseUs = () => {
  const leftCards = [
    {
      num: "01",
      text: "Deep expertise in state and central OA regulations",
    },
    {
      num: "02",
      text: "Proven execution capability across MW-scale OA projects",
    },
    { num: "03", text: "Strong DISCOM & SLDC coordination experience" },
  ];
  const rightCards = [
    {
      num: "04",
      text: "Transparent execution with complete lifecycle visibility",
    },
    {
      num: "05",
      text: "Robust engineering, top-tier quality, and stable long-term performance",
    },
    {
      num: "06",
      text: "Dedicated team for billing, settlement, and regulatory compliance",
    },
  ];

  return (
    <section className="open-access-why">
      {/* Header */}
      <div className="open-access-why-header">
        <p className="open-access-why-tag">
          <span className="open-access-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="open-access-why-title">
          Built For Seameless Open Access Execution 
        </h2>
      </div>

      {/* Body */}
      <div className="open-access-why-body">
        {/* Left cards */}
        <div className="open-access-why-col">
          {leftCards.map((c) => (
            <div className="open-access-why-card" key={c.num}>
              <p className="open-access-why-num">{c.num}</p>
              <p className="open-access-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        {/* Center image */}
        <div className="open-access-why-img-wrap">
          <img
            src={chooseImg}
            alt="Why Choose Us"
            className="open-access-why-img"
            loading="lazy"
          />
        </div>

        {/* Right cards */}
        <div className="open-access-why-col">
          {rightCards.map((c) => (
            <div className="open-access-why-card" key={c.num}>
              <p className="open-access-why-num">{c.num}</p>
              <p className="open-access-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 8 — FEATURED PROJECTS
   ================================================ */
const OpenFeaturedProjects = () => {
  const projects = [
    {
      img: featuredproj1,
      title: "Intra-State Open Access Solar Plant",
      desc: "A 25 MW ground-mounted solar plant supplying renewable power to multiple C&I consumers under Karnataka's open access framework.",
      tags: ["INTRA-STATE OA", "25 MW", "MULTI-CONSUMER"],
    },
    {
      img: featuredproj2,
      title: "Inter-State Open Access Portfolio",
      desc: "A 40 MW solar portfolio structured for inter-state open access, to procure renewable power at competitive tariffs.",
      tags: ["C&1", "INDUSTRIAL CLUSTER", "40 MW"],
    },
  ];

  return (
    <section className="openaccess-proj-section">
      <div className="openaccess-proj-header">
        <p className="openaccess-proj-tag">
          <span className="openaccess-proj-dot" />
          FEATURED PROJECTS
        </p>
        <h2 className="openaccess-proj-title">
          Open Access Projects Delivering Scalable Savings
        </h2>
      </div>

      <div className="openaccess-proj-grid">
        {projects.map((p, i) => (
          <div className="openaccess-proj-card" key={i}>
            <div className="openaccess-proj-img-wrap">
              <img src={p.img} alt={p.title} className="openaccess-proj-card-img" loading="lazy" />
            </div>
            <div className="openaccess-proj-card-body">
              <h3 className="openaccess-proj-card-title">{p.title}</h3>
              <p className="openaccess-proj-card-desc">{p.desc}</p>
              <div className="openaccess-proj-tags">
                {p.tags.map((tag, j) => (
                  <span className="openaccess-proj-tag-pill" key={j}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
// /* ================================================
//    5. TESTIMONIALS
//    ================================================ */
// const Testimonials = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Anjali Verma",
//       role: "Property Owner, Bengaluru",
//       quote:
//         '"True Renewables made our solar installation simple and hassle-free. The team was professional throughout the process."',
//       photo: Testi1,
//     },
//     {
//       id: 2,
//       name: "Sandeep Reddy",
//       role: "Managing Director, Reddy Commercial Spaces",
//       quote:
//         '"The installation was smooth and the system is performing very well. A reliable team to work with."',
//       photo: Testi2,
//     },
//     {
//       id: 3,
//       name: "Harshvardhan Kulkarni",
//       role: "Director, Altura Industrial Solutions",
//       quote:
//         '"True Renewables delivered a dependable solar solution for our facility and helped reduce our energy costs."',

//       photo: Testi3,
//     },
//   ];

//   // ── TESTIMONIAL CARD ──
//   const TestimonialCard = ({ item, animClass }) => (
//     <div className={`testi-card ${animClass || ""}`}>
//       <div className="testi-card-content">
//         <div className="testi-person">
//           <div>
//             <p className="testi-name">{item.name}</p>
//             <p className="testi-role">{item.role}</p>
//           </div>
//         </div>
//         <hr className="testi-divider" />
//         <p className="testi-quote">{item.quote}</p>
//       </div>
//       <div className="testi-card-photo">
//         {item.photo ? (
//           <img src={item.photo} alt={item.name} className="testi-photo" />
//         ) : (
//           <div className="testi-photo-placeholder" />
//         )}
//       </div>
//     </div>
//   );

//   const ChevronLeft = () => (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="15 18 9 12 15 6" />
//     </svg>
//   );

//   const ChevronRight = () => (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="9 18 15 12 9 6" />
//     </svg>
//   );

//   const [current, setCurrent] = useState(0);
//   const [slideDir, setSlideDir] = useState("");
//   const [animKey, setAnimKey] = useState(0);
//   const headerRef = useReveal();
//   const total = testimonials.length;

//   const prev = () => {
//     setSlideDir("testi-slide-left");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c - 1 + total) % total);
//   };

//   const next = () => {
//     setSlideDir("testi-slide-right");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c + 1) % total);
//   };

//   return (
//     <section className="testi-section">
//       <div className="testi-header reveal-block" ref={headerRef}>
//         <div className="testi-header-left">
//           <p className="testi-tag">
//             <span className="testi-dot"></span> TESTIMONIALS
//           </p>
//           <h2 className="testi-title">
//             Trusted By Clients Across
//             <br />
//             Industries
//           </h2>
//         </div>
//         <div className="testi-header-right">
//           <p className="testi-subtitle">
//             Real experiences from clients who trust us
//             <br />
//             with their solar journey.
//           </p>
//           <div className="testi-arrows testi-arrows-header">
//             <button
//               className="testi-arrow"
//               onClick={prev}
//               aria-label="Previous testimonial"
//             >
//               <ChevronLeft />
//             </button>
//             <button
//               className="testi-arrow"
//               onClick={next}
//               aria-label="Next testimonial"
//             >
//               <ChevronRight />
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="testi-cards" key={animKey}>
//         <TestimonialCard
//           item={testimonials[current % total]}
//           animClass={slideDir}
//         />
//         <TestimonialCard
//           item={testimonials[(current + 1) % total]}
//           animClass={`${slideDir} testi-delay`}
//         />
//       </div>
//     </section>
//   );
// };

/* ======================================================
   MAIN COMPONENT
====================================================== */
function OpenAccessSolar() {
  useEffect(() => {
    document.body.classList.add("captive-page");

    return () => {
      document.body.classList.remove("captive-page");
    };
  }, []);

  return (
    <div>
      <HeroSection />
      <OverviewSection />
      <ExplainerSection />
      <OpenAccessSolutions />
      <OpenSolarFinancialBenefits />
      <OpenWhoItsFor />
      <HowItWorks />
      <OpenWhyChooseUs />
      <OpenFeaturedProjects />
      {/* <Testimonials /> */}
    </div>
  );
}

export default OpenAccessSolar;
